export enum SurtitleTagType {
  None = 'None',
  Soft = 'Soft',
  Topic = 'Topic',
  AssetClass = 'AssetClass',
  Sector = 'Sector',
  Company = 'Company',
  Fund = 'Fund',
  InvestmentTrust = 'InvestmentTrust',
  Manager = 'Manager',
  Person = 'Person',
  Share = 'Share',
}
